import { render, staticRenderFns } from "./ProteccionesView.vue?vue&type=template&id=b20520d6&scoped=true"
import script from "./ProteccionesView.vue?vue&type=script&lang=js"
export * from "./ProteccionesView.vue?vue&type=script&lang=js"
import style0 from "./ProteccionesView.vue?vue&type=style&index=0&id=b20520d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20520d6",
  null
  
)

export default component.exports